import { cn } from '@/shared/lib/cn';

import styles from './Spinner.module.css';

export interface SpinnerProps {
  /** Диаметр в пикселях. */
  size?: number;
  className?: string;
  /** Доступное имя; по умолчанию спиннер декоративный. */
  label?: string;
}

export function Spinner({ size = 20, className, label }: SpinnerProps): React.ReactElement {
  return (
    <span
      className={cn(styles.spinner, className)}
      style={{ width: size, height: size, borderWidth: Math.max(1, Math.round(size / 12)) }}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
